import { getCallableNumber } from '@wazo/sdk/lib/utils/PhoneNumberUtil';

import PhoneNumber from '../../shared/calls/domain/PhoneNumber';

export const isExtensionValid = extension =>
  PhoneNumber.isValid(extension) && getCallableNumber(extension) === extension;
